import { Context, ContextEventHandlers } from "../platform-core";
import { Subject, Subscription } from "rxjs";

export namespace workItemContext {
  export const contextChange = new Subject<WorkItemContext>();

  let context: WorkItemContext;

  export function setContext(workItem: WorkItemContext): Context[] {
    context = workItem;

    if (!workItem || !workItem.Associations) {
      return [];
    }

    return workItem.Associations;
  }

  export function getContext(): WorkItemContext {
    return context;
  }

  export function unsetContext(): void {
    context = <WorkItemContext>(<unknown>undefined);
  }

  export function next() {
    contextChange.next(context);
  }

  export function subscribe(handlers: ContextEventHandlers): Subscription {
    return contextChange.subscribe(() => {
      if (context) {
        handlers.onSet(context);
      } else {
        handlers.onUnset();
      }
    });
  }

  export function isClosed(): boolean {
    return contextChange.closed;
  }
}

export type WorkItemContext = {
  WorkItemId: string;
  Associations?: Context[];
};
